import styled from "styled-components";

export const Container = styled.div<{
	scale: number;
	left: number;
	top: number;
	hasScrollEnded: boolean;
}>`
	//width: 331px;
	position: fixed;
	top: ${(props) => props.top}px;
	left: ${(props) => props.left}px;
	transform: scale(${(props) => props?.scale});
	transform-origin: center left;
	display: ${(props) => (props.hasScrollEnded ? "block" : "none")};

	@media (max-height: 599px) and (orientation: landscape) {
		display: flex;
	}
	@media (max-width: 359px) and (orientation: portrait) {
		transform-origin: top left;
	}
`;

export const ArrowContainer = styled.div`
	@media (min-height: 599px) or (orientation: portrait) {
		margin-left: 15%;
	}
	@media (max-height: 599px) and (orientation: landscape) {
		margin-right: 10%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
`;

export const SlideNumberContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-bottom: 4px;
	margin-right: 10px;
`;

export const StyledText = styled("div")`
	position: relative;
	margin: 0;
	color: #462c12;
	font-size: 16px;
	font-family: "Inter";
	font-weight: 700;
	line-height: 17px;
	z-index: 1;

	span {
		paint-order: stroke fill;
		-webkit-text-stroke-width: 2px;
		-webkit-text-stroke-color: #fbbd05;
	}
`;
